import React, { useState, useEffect, useRef, useMemo } from "react";

//bootstrap
import { Form, Row, Col, Button, ToastContainer } from "react-bootstrap";

//import redux
import { getPermissionUser } from "../../libs/redux/slices/authSlice/authSlice";
import { addArrayToQueue, setEmpnitxx, setQueueOwner } from "../../libs/redux/slices/queueSlice/queueSlice";
import { getDataUser } from "../../libs/redux/slices/authSlice/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { setShowErrors, setObjectErrors } from "../../libs/redux/slices/errorSlice/errorSlice";

import fileSlice from "../../libs/localforage/slices/fileSlice/fileSlice";
import { getPagesSplit, resetPagesSplit } from "../../libs/redux/slices/splitpdfSlice/splitpdfSlice";
import { setAreaSelected, setTypeSelected, setSerieSelected } from "../../libs/redux/slices/filterSlice/filterSlice";
import { useGetParentsByTypesMutation } from "../../libs/redux/slices/cretipxxSlice/cretipxxApiSlice";
//import create metadata
import Metadata from "../Metadata";
import Splitpdf from "../Splitpdf/Splitpdf";
import { countPages } from "../Splitpdf/numPages";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDocumentaryPackageMutation } from "../../libs/redux/slices/fileSlice/fileApiSlice";
import Confsald from "../Confsald";
import Selparxx from "../Selparxx";
import qs from "qs";
import { resolveContentType } from "../../libs/mimetype/mimetype";

import { Modal } from "react-bootstrap";

import {
  SATELLITE_KEYS,
  DEPENDENCIES_BY_FUNCTION,
  DEPENDENCIES_BY_METADATA,
} from "../../libs/metadata/dependencies";

const PER_DOCUMENT_TYPES = ["TEXTO", "NUMERO", "FECHA", "HORA", "EXCEL"];

//Conjunto de claves validas para los metadatos del tipo actual
const allowedKeys = (listMetadatas) => {
  const keys = new Set();
  if (Array.isArray(listMetadatas)) {
    listMetadatas.forEach((metadata) => {
      keys.add(metadata.METIDXXX);
      (SATELLITE_KEYS[metadata.METIDXXX] ?? []).forEach((key) => keys.add(key));
    });
  }
  return keys;
};

//Compara valores de metadato tolerando numero vs texto y listas
const isSameValue = (previous, next) => {
  if (Array.isArray(previous) || Array.isArray(next)) {
    return JSON.stringify(previous ?? "") === JSON.stringify(next ?? "");
  }
  return String(previous ?? "") === String(next ?? "");
};

//Un metadato se considera diligenciado solo si tiene un valor real
const hasMetadataValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  return value !== undefined && value !== null && value !== "";
};

//Descarta de un objeto de valores del formulario todo lo que no pertenezca al tipo actual
const pruneValues = (previous, keys) => {
  if (!previous || Array.isArray(previous)) return previous;
  const pruned = {};
  let hasChanges = false;
  Object.keys(previous).forEach((key) => {
    if (keys.has(key)) {
      pruned[key] = previous[key];
    } else {
      hasChanges = true;
    }
  });
  return hasChanges ? pruned : previous;
};

//Lee un archivo como base64 respetando el orden de seleccion
const readFileAsDataURL = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => resolve("");
    reader.readAsDataURL(file);
  });

const Selectop = () => {
  const [params] = useSearchParams();
  const fileClass = async () => await new fileSlice().createIndexFile();
  const [indexFile, setIndexFile] = useState();
  const [validated, setValidated] = useState(false);
  const dataPermission = useSelector(getPermissionUser);
  const dataUser = useSelector(getDataUser);
  const [company, setCompany] = useState(params.get("EMPNITXX") ? params.get("EMPNITXX") : "");
  const [areas, setAreas] = useState({});
  const [area, setArea] = useState(params.get("AREAIDXX") ? params.get("AREAIDXX") : "");
  const [series, setSeries] = useState({});
  const [serie, setSerie] = useState(params.get("SERIEIDX") ? params.get("SERIEIDX") : "");
  const [types, setTypes] = useState({});
  const [type, setType] = useState(params.get("TIPOIDXX") ? params.get("TIPOIDXX") : "");
  const [metadatas, setMetadatas] = useState({});
  const rawJSON = params.get("JSONMETX");
  const [jsonmetx, setJsonmetx] = useState(() => {
    try {
      if (!rawJSON) return {};
      const decoded = decodeURIComponent(rawJSON);
      try {
        return JSON.parse(decoded);
      } catch {
        return qs.parse(decoded, {
          allowDots: true,
          strictNullHandling: true,
        });
      }
    } catch (err) {
      console.error("Error parsing JSONMETX:", err);
      return {};
    }
  });

  const [file, setFile] = useState([]);
  const [contentType, setContentType] = useState([]);
  const [base64, setBase64] = useState([]);
  const [fileParents, setFileParents] = useState([]);
  const dispatch = useDispatch();
  const [isSplitPdf, setIsSplitPdf] = useState(false);
  const pagesSplit = useSelector(getPagesSplit);
  const [formData, setFormData] = useState(false);
  const [isClear, setIsClear] = useState(false);
  const fileInputRef = useRef(null);
  const [isPdf, setIsPdf] = useState(false);
  const [inputValue, setInputValue] = useState(() => {
    try {
      if (!rawJSON) return {};
      const decoded = decodeURIComponent(rawJSON);
      try {
        return JSON.parse(decoded);
      } catch {
        return qs.parse(decoded, {
          allowDots: true,
          strictNullHandling: true,
        });
      }
    } catch (err) {
      console.error("Error decoding inputValue:", err);
      return {};
    }
  });

  const [disableButton, setDisableButton] = useState(false);
  const [listPages, setListPages] = useState({});
  const [useParams, setUseParams] = useState(params.size > 0 ? true : false);
  const navigate = useNavigate();
  const [searchPack] = useDocumentaryPackageMutation();
  const [confirmSaldo, setConfirmSaldo] = useState(false);
  const formRef = useRef(null);
  const [getParentsByType] = useGetParentsByTypesMutation();
  const [parents, setParents] = useState([]);
  const [component, setComponent] = useState("");
  const [show, setShow] = useState(false);

  const loadAllPages = async (filters) => {
    let allResults = [];
    let foundTipos = new Set();
    let page = 0;
    let continueLoading = true;
    const pageSize = 16;

    while (continueLoading) {
      try {
        const response = await getParentsByType({
          ...filters,
          page: page
        }).unwrap();

        if (response?.data && response.data.length > 0) {
          const newResults = response.data.filter(item => {
            const isNewTipo = !foundTipos.has(item.TIPOIDPA);
            if (isNewTipo) foundTipos.add(item.TIPOIDPA);
            return isNewTipo;
          });

          allResults = allResults.concat(newResults);

          if (response.data.length < pageSize) {
            continueLoading = false;
          } else {
            page++;
          }
        } else {
          continueLoading = false;
        }
      } catch (error) {
        continueLoading = false;
      }
    }

    return allResults;
  };

  // Funcion para mostrar u Ocultar metadatos
  const shouldShowMetadata = (metadata) => {
    var showMetadata = true;
    switch (metadata.METIDXXX) {
      case "TIEMPANS":
        if (jsonmetx.CAPDAFAC !== "DATA ENTRY") {
          showMetadata = false;
        }
        break;
      default:
        showMetadata = true;
        break;
    }
    return showMetadata;
  };

  useEffect(() => {
    if (typeof indexFile === "undefined") {
      fileClass().then((response) => setIndexFile(response));
    }
  }, [indexFile]);

  const dependentsByKey = useMemo(() => {
    const map = {};
    const link = (child, parents) => {
      (parents ?? []).forEach((parent) => {
        if (!parent || parent === child) return;
        if (!map[parent]) map[parent] = new Set();
        map[parent].add(child);
      });
    };
    if (Array.isArray(metadatas)) {
      metadatas.forEach((metadata) => {
        const byFunction = DEPENDENCIES_BY_FUNCTION[metadata.METOPXXX];
        if (byFunction) link(metadata.METIDXXX, byFunction({ company, area }));
        link(metadata.METIDXXX, DEPENDENCIES_BY_METADATA[metadata.METIDXXX]);
      });
    }
    return map;
  }, [metadatas, company, area]);

  const staleKeysFor = (key) => {
    const stale = new Set();
    const walk = (currentKey) => {
      const children = [
        ...(SATELLITE_KEYS[currentKey] ?? []),
        ...(dependentsByKey[currentKey] ? Array.from(dependentsByKey[currentKey]) : []),
      ];
      children.forEach((child) => {
        if (stale.has(child)) return;
        stale.add(child);
        walk(child);
      });
    };
    walk(key);
    stale.delete(key);
    return Array.from(stale);
  };

  const clearPerDocumentMetadata = () => {
    const keysToClear = new Set();
    if (Array.isArray(metadatas)) {
      metadatas.forEach((metadata) => {
        if (!PER_DOCUMENT_TYPES.includes(metadata.METTIPXX)) return;
        keysToClear.add(metadata.METIDXXX);
        staleKeysFor(metadata.METIDXXX).forEach((staleKey) => keysToClear.add(staleKey));
      });
    }
    if (keysToClear.size === 0) return;
    const clear = (previous) => {
      const source = previous && !Array.isArray(previous) ? previous : {};
      const next = { ...source };
      keysToClear.forEach((key) => {
        next[key] = "";
      });
      return next;
    };
    setJsonmetx(clear);
    setInputValue(clear);
  };

  const updateJsonmetx = (key, value, label) => {
    const invalidatedKeys =
      hasMetadataValue(jsonmetx[key]) && !isSameValue(jsonmetx[key], value) ? staleKeysFor(key) : [];

    setJsonmetx((prevJsonmetx) => {
      const newJsonmetx = { ...prevJsonmetx };
      invalidatedKeys.forEach((staleKey) => {
        newJsonmetx[staleKey] = "";
      });
      if (key === "DIRECPRO" && value !== "") {
        const values = value.split(',-,');
        newJsonmetx[key] = values[0] || '';
        newJsonmetx["CLIPROCB"] = values[1] || '';
        newJsonmetx["APLVECIX"] = values[2] || '';
        newJsonmetx["PIEIDXXX"] = values[3] || '';
        newJsonmetx["PAIIDXXX"] = values[4] || '';
        newJsonmetx["DEPIDXXX"] = values[5] || '';
        newJsonmetx["CIUIDXXX"] = values[6] || '';
      } else if (key === "USRCONTR") {
        newJsonmetx[key] = value;
      } else {
        newJsonmetx[key] = value;
      }
      return newJsonmetx;
    });
    const newImputs = {
      [key]: ""
    };
    invalidatedKeys.forEach((staleKey) => {
      newImputs[staleKey] = "";
    });
    switch (key) {
      case "CLIIDXXX":
      case "DOCNROXX":
      case "PROIDXXX":
      case "USRCONTR":
      case "TRANSLOC":
      case "TRANINTX":
        if (label !== "" && label !== undefined) {
          newImputs[key] = [label];
        } else if (value !== "") {
          if (newImputs[key] !== undefined) {
            const ovaues = value.map((row) => {
              return { id: row, label: row };
            });
            newImputs[key] = ovaues;
          } else {
            newImputs[key] = [{ id: `${value}`, label: `${value}` }];
          }
        } else {
          newImputs[key] = value;
        }
        setInputValue((prevInput) => ({
          ...prevInput,
          ...newImputs
        }));
        break;

      default:
        setInputValue((prevInput) => ({
          ...prevInput,
          ...newImputs,
          [key]: value
        }));
        break;
    }
  };

  const validateMetadata = () => {
    let validate = true;
    let message = "";
    metadatas.length > 0
      ? metadatas.forEach((metadata) => {
        if (!shouldShowMetadata(metadata)) {
          return;
        }
        if (metadata.BANOBLXX === "SI") {
          if (!hasMetadataValue(jsonmetx[metadata.METIDXXX])) {
            message = message + "Debe Diligenciar: " + metadata.METDESXX + " ";
            validate = false;
          }
        } else {
          if (typeof jsonmetx[metadata.METIDXXX] === "undefined") {
            updateJsonmetx(metadata.METIDXXX, "");
          }
        }
      })
      : (validate = false);
    dispatch(setObjectErrors({ message }));
    dispatch(setShowErrors(!validate));
    return validate;
  };

  const handleSubmit = async (event, confirmDoctra = "") => {
    setDisableButton(true);
    const form = event.currentTarget;
    event.preventDefault();

    if (parents.length > 0 && fileParents.length === 0) {
      let message = "Debe seleccionar al menos un documento padre.";
      dispatch(setObjectErrors({ message }));
      dispatch(setShowErrors(true));
    } else {
      if (form.checkValidity() && validateMetadata()) {
        let metSend = {};
        metadatas.forEach((metadata) => {
          if (!shouldShowMetadata(metadata)) {
            metSend[`${metadata.METIDXXX}`] = "";
            return;
          }
          metSend[`${metadata.METIDXXX}`] = jsonmetx[metadata.METIDXXX] === undefined ? "" : jsonmetx[metadata.METIDXXX];
          if (metadata.METIDXXX === "DIRECPRO") {
            metSend["APLVECIX"] = jsonmetx["APLVECIX"] === undefined ? "" : jsonmetx["APLVECIX"];
            metSend["CLIPROCB"] = jsonmetx["CLIPROCB"] === undefined ? "" : jsonmetx["CLIPROCB"];
            metSend["PIEIDXXX"] = jsonmetx["PIEIDXXX"] === undefined ? "" : jsonmetx["PIEIDXXX"];
            metSend["PAIIDXXX"] = jsonmetx["PAIIDXXX"] === undefined ? "" : jsonmetx["PAIIDXXX"];
            metSend["DEPIDXXX"] = jsonmetx["DEPIDXXX"] === undefined ? "" : jsonmetx["DEPIDXXX"];
            metSend["CIUIDXXX"] = jsonmetx["CIUIDXXX"] === undefined ? "" : jsonmetx["CIUIDXXX"];
          }
          if (metadata.METIDXXX === "CLIIDXXX") {
            metSend["CATIDXXX"] = jsonmetx["CATIDXXX"] === undefined ? "" : jsonmetx["CATIDXXX"];
          }
          if (metadata.METIDXXX === "CLIIDXXX") {
            metSend["TRABANVE"] = jsonmetx["TRABANVE"] === undefined ? "" : jsonmetx["TRABANVE"];
            metSend["ODIIDXXX"] = jsonmetx["ODIIDXXX"] === undefined ? "" : jsonmetx["ODIIDXXX"];
          }
        });
        //si la serie es 100 consulto documento de transporte
        if (confirmDoctra === "" && metSend.TRADOCXX === "ORIGINAL") {
          switch (type) {
            case "100":
            case "101":
            case "147":
            case "562":
              let filts = "";
              if (metSend.NUMBLXXX) {
                filts += `&filters[JSONMETX][->][NUMBLXXX]=${metSend.NUMBLXXX}`;
              }
              if (metSend.DOCTRANS) {
                filts += `&filters[JSONMETX][->][DOCTRANS]=${metSend.DOCTRANS}`;
              }
              let filters = `filters[AREAIDXX]=100&filters[SERIEIDX]=100
              &filters[TIPOIDXX]=${type}
              &filters[JSONMETX][->][CLIIDXXX]=${metSend.CLIIDXXX}${filts}
              &filters[JSONMETX][->][TRADOCXX]=ORIGINAL
              &filters[REGESTXX]=ACTIVO`;
              const { data } = await searchPack({ filters: filters });
              if (data.data.length > 0) {
                setConfirmSaldo(true);
                return;
              }
              break;
            default:
              break;
          }
        }
        const positions = [];
        const baseIndex = await new fileSlice().createIndexFile();
        for (let i = 0; i < file.length; i++) {
          const currentFile = file[i];
          const currentContentType = contentType[i];
          const currentBase64 = base64[i];
          const fileClass = new fileSlice(currentFile, currentBase64, currentContentType, baseIndex + i);
          //Valido el size del archivo
          if (currentFile.size < process.env.REACT_APP_GENIO_FILE_SIZE) {
            await fileClass.saveFileBase64().then(async (response) => {
              const position = {
                EMPNITXX: company,
                AREAIDXX: area,
                SERIEIDX: serie,
                TIPOIDXX: type,
                JSONMETX: metSend,
                FILEINDE: response.keyFile,
                TYPEXXXX: currentContentType,
                NAMEXXXX: currentFile.name,
                SIZEKBXX: currentFile.size / 1000,
                ISBASE64: true,
                URLPRESI: "",
                INPROCES: false,
                PAGSPLIT: pagesSplit[i],
                IDARCHXX: 0,
                INTENTOS: 0,
                NEWSALDO: confirmDoctra,
                PARENTSX: fileParents,
              };
              positions.push(position);
              fileClass.addIndexFile();
            });
            dispatch(resetPagesSplit());
          } else {
            await fileClass.saveFileBlob().then((response) => {
              const position = {
                EMPNITXX: company,
                AREAIDXX: area,
                SERIEIDX: serie,
                TIPOIDXX: type,
                JSONMETX: metSend,
                FILEINDE: response.keyFile,
                TYPEXXXX: currentContentType,
                NAMEXXXX: currentFile.name,
                SIZEKBXX: currentFile.size / 1000,
                ISBASE64: false,
                URLPRESI: "",
                INPROCES: false,
                PAGSPLIT: pagesSplit[i],
                IDARCHXX: 0,
                INTENTOS: 0,
                NEWSALDO: confirmDoctra,
              };
              positions.push(position);
              fileClass.addIndexFile();
            });
            dispatch(resetPagesSplit());
          }
        }
        setIndexFile(baseIndex + file.length);
        if (dataUser?.USRIDXXX) {
          dispatch(setQueueOwner(dataUser.USRIDXXX.toString()));
        }
        dispatch(addArrayToQueue(positions));
        if (isClear) {
          resetValue();
          clearPerDocumentMetadata();
        } else {
          reset();
        }
        setFileParents([]);
      } else {
        setValidated(true);
        event.preventDefault();
      }
    }
    setDisableButton(false);
  };

  const oConfirmDoctra = (value, event) => {
    event.preventDefault();
    setConfirmSaldo(false);
    handleSubmit(event, value);
  };

  const resetValue = () => {
    setValidated(false);
    setFormData(false);
    setFile([]);
    setContentType([]);
    setBase64([]);
    setListPages({});
    setIsPdf(false);
    setIsSplitPdf(false);
    setUseParams(false);
    dispatch(resetPagesSplit());
    const fileInput = fileInputRef.current;
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const reset = () => {
    setIsClear(false);
    setValidated(false);
    document.getElementById("idForm").reset();
    setCompany("");
    setArea("");
    setSerie("");
    setType("");
    setAreas({});
    setSeries({});
    setTypes({});
    setMetadatas({});
    setJsonmetx({});
    setFile([]);
    setContentType([]);
    setBase64([]);
    setListPages({});
    setIsPdf(false);
    setIsSplitPdf(false);
    setParents([]);
    setFileParents([]);
    dispatch(resetPagesSplit());
    setInputValue({});
    setUseParams(false);
    const fileInput = fileInputRef.current;
    if (fileInput) {
      fileInput.value = null;
    }
    navigate("/");
  };

  //useEffect for companys
  useEffect(() => {
    if (company !== "") {
      dispatch(setEmpnitxx(company));
      let preAreas = dataPermission.filter((SYS00013) => {
        return SYS00013.EMPNITXX === company.toString() ?? SYS00013;
      });
      setAreas(preAreas[0].GEST0001);
      if (!useParams) {
        setJsonmetx({});
      }
    } else {
      setAreas({});
      setSeries({});
    }
    // eslint-disable-next-line
  }, [company, dataPermission]);

  //useEffect for areas
  useEffect(() => {
    if (area !== "" && Object.entries(areas).length > 0) {
      dispatch(setAreaSelected(area));
      let preSeries = areas.filter((GEST0001) => {
        return GEST0001.AREAIDXX === parseInt(area) ?? GEST0001;
      });
      setSeries(preSeries[0]?.GEST0002);
      if (!isClear && !useParams) {
        setJsonmetx({});
      }
    } else {
      setSeries({});
      setTypes({});
    }
    if (!isClear && !useParams) {
      setInputValue([]);
    }
    // eslint-disable-next-line
  }, [area, areas]);

  //useEffect to series
  useEffect(() => {
    if (serie !== "" && typeof series !== "undefined" && Object.entries(series).length > 0) {
      dispatch(setSerieSelected(serie));
      let preType = series.filter((GEST0002) => {
        return GEST0002.SERIEIDX === parseInt(serie) ?? GEST0002;
      });
      setTypes(preType[0]?.GEST0003);
      if (!isClear && !useParams) {
        setJsonmetx({});
      } else {
        switch (area) {
          case "100":
          case "101":
            if (!isClear && !useParams) {
              resetValue();
            }
            break;
          default:
            if (!useParams) {
              setJsonmetx({});
              setInputValue([]);
            }
            break;
        }
      }
    } else {
      setTypes({});
    }
    if (!isClear && !useParams) {
      setInputValue([]);
    }
    // eslint-disable-next-line
  }, [serie, series]);

  //useEffect to types
  useEffect(() => {
    if (type !== "" && typeof types !== "undefined" && Object.entries(types).length > 0) {
      dispatch(setTypeSelected(type));
      let preMetadatas = types.filter((GEST0003) => {
        return GEST0003.TIPOIDXX === parseInt(type) ?? GEST0003;
      });
      setMetadatas(preMetadatas[0]?.GEST0004);
      if (!isClear && !useParams) {
        setJsonmetx({});
      } else if (!useParams) {
        resetValue();
      }
    } else if (!useParams) {
      setMetadatas({});
    }
    if (!isClear && !useParams) {
      setInputValue([]);
    }
    // eslint-disable-next-line
  }, [type, types]);

  useEffect(() => {
    if (!Array.isArray(metadatas) || metadatas.length === 0) return;
    const keys = allowedKeys(metadatas);
    setJsonmetx((previous) => pruneValues(previous, keys));
    setInputValue((previous) => pruneValues(previous, keys));
  }, [metadatas]);

  //contar paginas de un pdf
  const onFileChange = async (file, index) => {
    try {
      const numPages = await countPages(file);
      // console.log("Numero de paginas: ", numPages);
      setListPages((list) => ({ ...list, [index]: numPages }));
    } catch (error) {
      console.log("Error al contar las paginas: ", error);
    }
  };

  const handleChangeType = async (value) => {
    dispatch(setTypeSelected(value));
    setParents(await checkIfParentApplies(value));
  }

  const checkIfParentApplies = async (TIPOIDXX) => {
    return await loadAllPages({
      EMPNITXX: company,
      AREAIDXX: area,
      SERIEIDX: serie,
      TIPOIDXX: TIPOIDXX,
    });
  };

  let oComponent;
  switch (component) {
    case "SELECCIONAR DOCUMENTO PADRE":
      oComponent =
        <Selparxx
          onClose={setShow}
          EMPNITXX={company}
          AREAIDXX={area}
          TIPOIDXX={type}
          CLIIDXXX={jsonmetx.hasOwnProperty("CLIIDXXX") ? jsonmetx.CLIIDXXX : []}
          parents={parents}
          setFileParents={setFileParents}
        />;
      break;
    default:
      break;
  }
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} className="modal-xl">
        <Modal.Header closeButton>
          <Modal.Title>{component}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{oComponent}</Modal.Body>
      </Modal>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit} id="idForm">
        {confirmSaldo && (
          <ToastContainer className="p-3" position="top-end" showCloseButton>
            <Confsald onConfirm={oConfirmDoctra} />
          </ToastContainer>
        )}
        <Row md={12} className="mt-3">
          <Form.Group as={Col} md={3}>
            <Form.Label>Empresa: *</Form.Label>
            <Form.Select
              value={company}
              name="EMPDESXX"
              required
              onChange={(e) => {
                setUseParams(false);
                setCompany(e.target.value);
                dispatch(setEmpnitxx(e.target.value));
              }}
            >
              <option value={""}>[SELECCIONE]</option>
              {dataPermission.map((SYS00013) => {
                return (
                  <option value={SYS00013.EMPNITXX} key={SYS00013.EMPNITXX}>
                    {SYS00013.EMPDESXX}
                  </option>
                );
              })}
            </Form.Select>
            <Form.Control.Feedback type="invalid">Debe Seleccionar una Empresa</Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={3}>
            <Form.Label>Proceso: *</Form.Label>
            <Form.Select
              required
              value={area}
              name="AREAIDXX"
              onChange={(e) => {
                setUseParams(false);
                setArea(e.target.value);
                dispatch(setAreaSelected(e.target.value));
              }}
            >
              <option value={""}>[SELECCIONE]</option>
              {areas?.length > 0
                ? areas?.map((GEST0001) => {
                  return (
                    <option value={GEST0001.AREAIDXX} key={GEST0001.AREAIDXX}>
                      {GEST0001.AREADESX}
                    </option>
                  );
                })
                : ""}
            </Form.Select>
            <Form.Control.Feedback type="invalid">Debe Seleccionar un Area</Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={3}>
            <Form.Label>Serie: *</Form.Label>
            <Form.Select
              value={serie}
              required
              name="SERIEIDX"
              onChange={(e) => {
                setUseParams(false);
                setSerie(e.target.value);
                dispatch(setSerieSelected(e.target.value));
              }}
            >
              <option value={""}>[SELECCIONE]</option>
              {series?.length > 0
                ? series?.map((GEST0002) => {
                  return (
                    <option value={GEST0002.SERIEIDX} key={GEST0002.SERIEIDX}>
                      {GEST0002.SERIEDES}
                    </option>
                  );
                })
                : ""}
            </Form.Select>
            <Form.Control.Feedback type="invalid">Debe Seleccionar una Serie</Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={3}>
            <Form.Label>Tipo: *</Form.Label>
            <Form.Select
              value={type}
              required
              name="TIPOIDXX"
              onChange={(e) => {
                setUseParams(false);
                setType(e.target.value);
                handleChangeType(e.target.value);
              }}
            >
              <option value={""}>[SELECCIONE]</option>
              {types?.length > 0
                ? types?.map((GEST0003) => {
                  return (
                    <option value={GEST0003.TIPOIDXX} key={GEST0003.TIPOIDXX}>
                      {GEST0003.TIPODESX}
                    </option>
                  );
                })
                : ""}
            </Form.Select>
            <Form.Control.Feedback type="invalid">Debe Seleccionar un Tipo</Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row className="align-items-end">
          {metadatas?.length > 0
            ? metadatas
              .filter(shouldShowMetadata)
              .map((GEST0004) => {
                let width = 3;
                GEST0004 = { ...GEST0004 };
                const currentValue = jsonmetx[GEST0004.METIDXXX];
                const hasValue = Array.isArray(currentValue)
                  ? currentValue.length > 0
                  : currentValue !== undefined && currentValue !== null && currentValue !== "";
                if (hasValue) {
                  GEST0004.BANOBLXX = "NO";
                }
                switch (GEST0004.METTIPXX) {
                  case "LISTASELECCION":
                  case "LISTASELECCIONFUNCION":
                  case "LISTASELECCIONFUNCIONMULTIPLE":
                    width = 6;
                    break;
                  case "EXCEL":
                    width = 12;
                    break;
                  default:
                    width = 3;
                    break;
                }
                return (
                  <Col md={width} key={GEST0004.METIDXXX}>
                    <Metadata
                      GEST0004={GEST0004}
                      setJsonmetx={updateJsonmetx}
                      inputValue={inputValue}
                      jsonmetx={jsonmetx}
                    />
                  </Col>
                );
              })
            : ""}
        </Row>
        {parents.length > 0
          && (jsonmetx.hasOwnProperty("CLIIDXXX") ? jsonmetx.CLIIDXXX !== "" : false)
          && (<Row className="mt-3">
            <Form.Label
              onClick={() => {
                setComponent("SELECCIONAR DOCUMENTO PADRE");
                setShow(true);
              }}
              style={{
                cursor: "pointer",
                textDecoration: "underline"
              }}
            >
              SELECCIONA DOCUMENTO PADRE*
            </Form.Label>
            {fileParents.map((item, index) => (
              <div key={`parent-${index}`}>{item.METAKEYX} - {item.METAVALX !== "" ? item.METAVALX : "SIN METADATO"}<br /></div>
            ))}
          </Row>)}
        <Row className="mt-3">
          <Form.Label>Archivo: *</Form.Label>
          <Form.Control
            type="file"
            ref={fileInputRef}
            accept={dataUser.EXTENSXX}
            required
            multiple
            onChange={async (e) => {
              const selectedFiles = Array.from(e.target.files);
              setFile([]);
              setContentType([]);
              setBase64([]);
              setListPages({});
              setIsSplitPdf(false);
              dispatch(resetPagesSplit());
              if (selectedFiles.length === 0) {
                setIsPdf(false);
                setFormData(false);
                return;
              }
              const contents = await Promise.all(selectedFiles.map(readFileAsDataURL));
              const validIndexes = contents
                .map((content, index) => (content !== "" ? index : -1))
                .filter((index) => index >= 0);
              const validFiles = validIndexes.map((index) => selectedFiles[index]);
              //Normalizo el tipo mime: el navegador no reconoce todas las extensiones (.eml)
              const validTypes = validFiles.map((currentFile) => resolveContentType(currentFile));
              setFile(validFiles);
              setContentType(validTypes);
              setBase64(validIndexes.map((index) => contents[index]));
              const allPdf = validTypes.length > 0 && validTypes.every((type) => type === "application/pdf");
              setIsPdf(allPdf);
              if (allPdf) {
                await Promise.all(validFiles.map((currentFile, index) => onFileChange(currentFile, index)));
              }
              setFormData(validFiles.length > 0);
            }}
          ></Form.Control>
          <Form.Control.Feedback type="invalid">Debe Adjuntar un Archivo</Form.Control.Feedback>
        </Row>

        {base64.length > 0 && isPdf && (
          <>
            <br />
            <Row>
              <Col>
                Dividir PDF{" "}
                <Form.Check
                  type="radio"
                  label="SI"
                  name="SPLITPDF"
                  value="SI"
                  inline
                  onClick={() => {
                    setIsSplitPdf(true);
                  }}
                />
                <Form.Check
                  type="radio"
                  label="NO"
                  name="SPLITPDF"
                  value="NO"
                  inline
                  onClick={() => {
                    setIsSplitPdf(false);
                    dispatch(resetPagesSplit());
                  }}
                />
              </Col>
            </Row>
            <br />
          </>
        )}
        {isSplitPdf && (
          <Row>
            {base64.map((item, index) => (
              <Col key={index}>
                <Splitpdf numPages={listPages[index]} index={index} nameFile={file[index].name} />
              </Col>
            ))}
          </Row>
        )}
        <Row md={12} className="mt-3 mb-3">
          <Col md={2}>
            <Button
              className="w-100"
              disabled={disableButton}
              onClick={() => {
                reset();
              }}
            >
              LIMPIAR
            </Button>
          </Col>
          <Col md={2}>
            <Button
              type="submit"
              className="w-100"
              disabled={disableButton}
              onClick={() => {
                setIsClear(false);
              }}
            >
              <span>CREAR CARGUE</span>
            </Button>
          </Col>
          {formData ? (
            <Col md={2}>
              <Button
                disabled={disableButton}
                type="submit"
                className="w-100"
                onClick={() => {
                  setIsClear(true);
                }}
              >
                CONSERVAR DATOS
              </Button>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Form>
    </>
  );
};

export default Selectop;
